// import React, { useState, useEffect, useCallback, useRef } from "react";
// import {
//     Grid,
//     Paper,
//     Typography,
//     Divider,
//     Button,
//     Box,
//     IconButton,

//     Chip,
//     Avatar,
//     alpha,
//     useTheme,
//     Table,
//     TableBody,
//     TableCell,
//     TableContainer,
//     TableHead,
//     TableRow,
//     Tooltip,
//     Zoom,

//     InputAdornment,
//     Stack,

//     Badge,
//     TextField,
//     Fab,
// } from "@mui/material";
// import {
//     Add as AddIcon,
//     Delete as DeleteIcon,
//     Receipt as ReceiptIcon,
//     Percent as PercentIcon,
//     Calculate as CalculateIcon,
//     Save as SaveIcon,
//     QrCode as QrCodeIcon,
//     ShoppingCart as CartIcon,
//     Person as PersonIcon,
//     ArrowForward as ArrowForwardIcon,
//     ReceiptLong as ReceiptLongIcon,
//     Download as DownloadIcon,
//     Print as PrintIcon,
//     Phone as PhoneIcon,
//     ShoppingCartOutlined as ShoppingCartIcon,
//     Email as EmailIcon,
//     ArrowBack as ArrowBackIcon,
//     CheckCircle as CheckCircleIcon,
//     LocalOffer as LocalOfferIcon,
//     QrCodeScanner as QrCodeScannerIcon,
//     Search as SearchIcon,
//     Payment as PaymentIcon,
//     Home as HomeIcon,
//     Cancel as CancelIcon,
// } from "@mui/icons-material";
// import { useForm, useFieldArray } from "react-hook-form";
// import { useNavigate, useParams } from "react-router-dom";

// import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
// import { callAPI, formatCurrency, Method } from "../../commonFunctions/CommonFunctions";
// import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";

// import WSDateField from "../../Components/DateField/WSDateField";
// import WSButton from "../../Components/Button/WSButton";
// import WSLoadingOverlay from "../../Components/Loader/WSLoadingOverlay";
// import WSPhone from "../../Components/Phone/WSPhone";

// // Thermal print styles for 80mm paper
// const thermalPrintStyles = `
//   @page {
//     size: 80mm auto;
//     margin: 0;
//   }
//   @media print {
//     body {
//             font-family: Arial, sans-serif;
//             font-size: 14px;
//             margin: 0;
//             padding: 0;
//             line-height:2;
//           }

//            #thermal-receipt {
//             width: 80mm;
//             max-width: 80mm;
//             margin: auto;
//             padding: 4px;
//           }

//     .print-header {
//       text-align: center;
//       font-weight: bold;
//       font-size: 22px;
//       margin-bottom: 5px;
//     }
//     .print-shop {
//       text-align: center;
//       font-size: 14px;
//       font-weight: 600;
//       line-height:2;
//       margin-bottom: 10px;
//     }
//     .print-divider {
//       border-top: 1px dashed #000;
//       margin: 5px 0;
//     }
//     .print-row{
//   display:flex;
//   justify-content:space-between;
//   align-items:flex-start;
//   margin:2px 0;
// }
//     .print-row .customerName{
//     line-height:2;
//     }

//     .customer-line{
//   word-break: break-word;
//   white-space: normal;
// }

//     .print-row .phone{
//     line-height:2;
//     }

//     .print-footer {
//       text-align: center;
//       margin-top: 10px;
//       font-size: 9px;
//     }
//   }
// `;

// interface InvoiceItem {
//     id: string;
//     barcode: string;
//     productName: string;
//     hsnCode: string;
//     quantity: number;
//     unitPrice: number;
//     discount: number;
//     taxRate: number;
//     total: number;
//     productId: string;
// }

// interface InvoiceFormData {
//     invoiceNo: string;
//     invoiceDate: Date;
//     customerName: string;
//     customerPhone: string;
//     customerAddress: string;
//     items: InvoiceItem[];
//     discount: number;
//     notes: string;
// }

// const InvoicePage: React.FC = () => {
//     const theme = useTheme();
//     const navigate = useNavigate();
//     const params = useParams();
//     const id = params?.id;
//     const { showMessage } = useSnackbar();

//     const printRef = useRef<HTMLDivElement>(null);
//     const barcodeRef = useRef<HTMLInputElement>(null);

//     const [loading, setLoading] = useState(false);
//     // const [scanning, setScanning] = useState(false);
//     const [scanningInput, setScanningInput] = useState(false);
//     const [barcodeInput, setBarcodeInput] = useState('');
//     const [paymentMethod, setPaymentMethod] = useState('UPI'); // Default UPI
//     const [calculatedValues, setCalculatedValues] = useState({
//         subtotal: 0,
//         totalDiscount: 0,
//         totalTax: 0,
//         total: 0,
//     });

//     const { control, register, watch, setValue, getValues, handleSubmit } = useForm<InvoiceFormData>({
//         defaultValues: {
//             // invoiceNo: '',
//             invoiceDate: new Date(),
//             customerName: '',
//             customerPhone: '',
//             customerAddress: '',
//             items: [],
//             discount: 0,
//             notes: '',
//         }
//     });

//     const { fields, append, remove } = useFieldArray({
//         name: "items",
//         control,
//     });

//     const watchItems = watch("items");

//     useEffect(() => {
//         barcodeRef.current?.focus();
//     }, []);

//     useEffect(() => {
//         const handleKeyDown = (event: KeyboardEvent) => {

//             // Save (Ctrl + S)
//             if (event.ctrlKey && event.key.toLowerCase() === "s") {
//                 event.preventDefault(); // prevent browser save page
//                 handleSave();
//             }

//             // Save & Print (Ctrl + P)
//             if (event.ctrlKey && event.key.toLowerCase() === "p") {
//                 event.preventDefault(); // prevent browser print
//                 handleSaveAndPrint();
//             }

//             // Cancel (Esc)
//             if (event.key === "Escape") {
//                 handleCancel();
//             }
//         };

//         window.addEventListener("keydown", handleKeyDown);

//         return () => {
//             window.removeEventListener("keydown", handleKeyDown);
//         };
//     }, []);

//     // Calculate invoice totals
//     useEffect(() => {
//         calculateInvoiceTotals();
//     }, [watchItems]);

//     const calculateInvoiceTotals = useCallback(() => {
//         const items = getValues("items") || [];

//         let subtotal = 0;
//         let totalDiscount = 0;
//         let totalTax = 0;

//         items.forEach((item: any, index: number) => {
//             const quantity = Number(item.quantity) || 1;
//             const unitPrice = Number(item.unitPrice) || 0;
//             const discount = Number(item.discount) || 0;
//             const taxRate = Number(item.taxRate) || 0;

//             const itemSubtotal = quantity * unitPrice;
//             const itemDiscount = (itemSubtotal * discount) / 100;
//             const taxableValue = itemSubtotal - itemDiscount;
//             const itemTax = (taxableValue * taxRate) / 100;

//             subtotal += itemSubtotal;
//             totalDiscount += itemDiscount;
//             totalTax += itemTax;

//             // Update item total
//             setValue(`items.${index}.total` as any, taxableValue + itemTax);
//         });

//         setCalculatedValues({
//             subtotal,
//             totalDiscount,
//             totalTax,
//             total: subtotal - totalDiscount + totalTax,
//         });
//     }, [watchItems, setValue, getValues]);

//     // Handle barcode scan
//     const handleBarcodeScan = async (barcode: string) => {
//         try {
//             setLoading(true);
//             const response = await callAPI(`Vyapar/Product/by-barcode/${barcode}`, Method.GET);

//             console.log("Barcode scan response:", response);

//             if (response.success && response.data) {
//                 const product = response.data;

//                 // Add new item with scanned product
//                 append({
//                     id: Date.now().toString(),
//                     barcode: barcode,
//                     productId: product.id,
//                     productName: product.name,
//                     hsnCode: product.hsnSac || '',
//                     quantity: 1,
//                     unitPrice: product.salePrice || 0,
//                     discount: 0,
//                     taxRate: product.gstPercent || 0,
//                     total: product.salePrice || 0,
//                 });

//                 showMessage(`${product.name} added`, 'success');
//                 setBarcodeInput('');
//                 barcodeRef.current?.focus();
//             } else {
//                 showMessage('Product not found', 'warning');
//             }
//         } catch (error) {
//             showMessage('Failed to fetch product', 'error');
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Handle barcode input keypress
//     const handleBarcodeKeyPress = (e: React.KeyboardEvent) => {
//         if (e.key === "Enter") {
//             e.preventDefault(); // 🚀 prevents form submit
//             if (barcodeInput) {
//                 handleBarcodeScan(barcodeInput);
//             }
//         }
//     };

//     // Handle item change
//     const handleItemChange = (index: number, field: string, value: any) => {

//         setValue(`items.${index}.${field}` as any, value);

//         // Recalculate after state update
//         setTimeout(() => {
//             calculateInvoiceTotals();
//         }, 0);
//     };

//     const handleSave = () => {
//         handleSubmit((data) => onSubmit(data, true))();
//     };

//     const handleSaveAndPrint = () => {
//         handleSubmit((data) => onSubmit(data, true))();
//     };

//     const handleCancel = () => {
//         navigate("/invoice/list");
//     };

//     // Thermal print function
//     const handlePrint = (data: any) => {

//         const printWindow = window.open('', '_blank', 'width=800,height=600');

//         if (printWindow && printRef.current) {

//             const shopName = "RANGOLI COLLECTIONS";
//             const shopAddress = "Iritty Rd, Chavassery Near town bus stop, Kerala 670702";
//             const shopPhone = "+91 7594032123";

//             const invoiceDate = new Date(data.invoiceDate);

//             const receiptHTML = `
// <!DOCTYPE html>
// <html>
// <head>
// <title>Print Receipt</title>
// <style>${thermalPrintStyles}</style>
// </head>

// <body>
// <div id="thermal-receipt">

//   <div class="print-header">${shopName}</div>
//   <div class="print-shop">${shopAddress}</div>
//   <div class="print-shop">Ph: ${shopPhone}</div>

//   <div style="text-align:center;font-weight:bold;font-size:12px;margin-top:4px;">
//     SALES INVOICE
//   </div>

//   <div class="print-divider"></div>

//   <div class="print-row">
//   <span class="invoice">Invoice: ${data.invoiceNo}</span>

//   <span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;">
//     <span>Date: ${invoiceDate.toLocaleDateString()}</span>
//     <span style="font-size:12px; margin-top:4px">Time: ${invoiceDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
//   </span>
// </div>

//   <div class="customer-line">
//   Customer: 
//   <span style="font-size:12px">${data.customerName || 'Walk-in'} </span>
// </div>

//   <div class="print-row">
//     <span>Phone: ${data.phoneNumber || 'N/A'}</span>
//   </div>

//   <div class="print-divider"></div>

//   <table style="width:100%;font-size:11px;">
//     <thead>
//       <tr>
//         <th style="text-align:left;">Item</th>
//         <th style="text-align:right;">Qty</th>
//         <th style="text-align:right;">Price</th>
//         <th style="text-align:right;">Total</th>
//       </tr>
//     </thead>

//     <tbody>
//       ${data.items.map((item: any) => `
//         <tr>
//           <td style="text-align:left;">${"item.productName.substring(0, 15)"}</td>
//           <td style="text-align:right;">${item.quantity}</td>
//           <td style="text-align:right;">${item.pricePerUnit.toFixed(2)}</td>
//           <td style="text-align:right;">${item.amount.toFixed(2)}</td>
//         </tr>
//       `).join('')}
//     </tbody>
//   </table>

//   <div class="print-divider"></div>

//   <div class="print-row">
//     <span>Subtotal</span>
//     <span>₹ ${calculatedValues.subtotal.toFixed(2)}</span>
//   </div>

//   <div class="print-row">
//     <span>Discount</span>
//     <span>- ₹ ${calculatedValues.totalDiscount.toFixed(2)}</span>
//   </div>

//   <div class="print-row" style="font-weight:bold;font-size:14px; margin-top:3px;">
//     <span>TOTAL</span>
//     <span>₹ ${data.total.toFixed(2)}</span>
//   </div>

//   <div class="print-divider"></div>

//   <div class="print-row">
//     <span>Payment</span>
//     <span>${paymentMethod.toUpperCase()}</span>
//   </div>

//   <div class="print-footer">
//     Thank you for shopping! <br/>
//     Visit Again
//   </div>

// </div>
// </body>
// </html>
// `;

//             printWindow.document.write(receiptHTML);
//             printWindow.document.close();
//             printWindow.focus();

//             setTimeout(() => {
//                 printWindow.print();
//                 printWindow.onafterprint = () => {
//                     printWindow.close();
//                 };
//             }, 300);
//         }
//     };

//     // Submit handler
//     const onSubmit = async (data: any, isPrint = false) => {
//         console.log("data are", data);

//         try {
//             setLoading(true);

//             const request = {
//                 ...calculatedValues,
//                 CustomerName: data.customerName || "Cash Customer",
//                 PhoneNumber: data.customerPhone || "",
//                 invoiceDate: data.invoiceDate || "",
//                 invoiceNo: data.invoiceNo || "",
//                 stateOfSupply: data.stateOfSupply || "",
//                 description: data.description || "",
//                 paymentType: paymentMethod,

//                 items: (data.items || []).map((item: any) => ({
//                     productId: item.productId || "",
//                     productName: item.productName || "",
//                     itemCode: item.itemCode || "",
//                     hsnCode: item.hsnCode || "",
//                     description: item.description || "",
//                     quantity: Number(item.quantity || 0),
//                     pricePerUnit: Number(item.unitPrice || 0),
//                     discount: Number(item.discount || 0),
//                     amount: Number(item.amount || 0),
//                     // total: Number(item.total) || 0,
//                 })),
//             };

//             console.log('request payload to server', request);

//             let response;
//             if (id) {
//                 response = await callAPI(`Vyapar/SaleInvoice/${id}`, Method.PUT, request);
//             } else {
//                 response = await callAPI('Vyapar/SaleInvoice', Method.POST, request);
//             }

//             console.log("API response after saving invoice:", response);

//             if (response?.success) {
//                 showMessage('Invoice saved successfully', 'success');

//                 // Check which action to perform
//                 if (isPrint) {
//                     handlePrint(response.data);
//                 }
//                 else {
//                     navigate('/invoice/list');
//                 }
//             }

//             console.log("handleData response===>", response);

//         } catch (error: any) {
//             console.error("Failed to save invoice:", error);
//             showMessage(error.response?.data?.message || 'Failed to save invoice', 'error');
//         } finally {
//             setLoading(false);
//         }
//     };

//     return (
//         <Box sx={{ p: 2, maxWidth: 1400, mx: 'auto' }}>
//             <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
//                 {/* Header */}
//                 <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//                     <Grid container spacing={2} alignItems="center">
//                         {/* Billing Title */}
//                         <Grid item xs={12} md={3}>
//                             <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
//                                     <ReceiptIcon />
//                                 </Avatar>

//                                 <Box>
//                                     <Typography variant="h6" sx={{ fontWeight: 600 }}>
//                                         Start Billing
//                                     </Typography>

//                                     <Typography variant="caption" color="text.secondary">
//                                         New Sale Invoice
//                                     </Typography>
//                                 </Box>
//                             </Box>
//                         </Grid>

//                         {/* Action Buttons */}
//                         <Grid item xs={12} md={9}>
//                             <Box
//                                 sx={{
//                                     display: "flex",
//                                     justifyContent: "flex-end",
//                                     gap: 1,
//                                     flexWrap: "wrap"
//                                 }}
//                             >
//                                 <WSButton
//                                     id="cancelBtn"
//                                     variant="outlined"
//                                     color="error"
//                                     size="small"
//                                     label="Cancel"
//                                     onClick={() => navigate('/invoice/list')}
//                                 />

//                                 <WSButton
//                                     id="saveAndPrintBtn"
//                                     variant="contained"
//                                     color="secondary"
//                                     size="small"
//                                     startIcon={<PrintIcon />}
//                                     label="Save & Print"
//                                     onClick={handleSaveAndPrint}
//                                 />

//                                 <WSButton
//                                     id="saveBtn"
//                                     variant="contained"
//                                     color="primary"
//                                     size="small"
//                                     label="Save"
//                                     type="submit"
//                                     startIcon={<SaveIcon />}
//                                 />
//                             </Box>
//                         </Grid>
//                     </Grid>
//                 </Paper>

//                 <Grid container spacing={2}>
//                     {/* Left Column - Customer & Items */}
//                     <Grid item xs={12} lg={8}>
//                         {/* Customer Section */}
//                         <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <PersonIcon color="primary" />
//                                 Customer Details
//                             </Typography>

//                             <Grid container spacing={2}>
//                                 <Grid item xs={12} md={4}>
//                                     <WSTextField
//                                         id="customerName"
//                                         label="Customer Name"
//                                         {...register("customerName")}
//                                         control={control}
//                                         size="small"
//                                         suffix={<PersonIcon fontSize="small" />}
//                                         rules={{ required: false }}
//                                     />
//                                 </Grid>

//                                 <Grid item xs={12} md={4}>
//                                     <WSPhone
//                                         id="customerPhone"
//                                         label="Phone Number"
//                                         {...register("customerPhone")}
//                                         control={control}
//                                         size="small"

//                                         rules={{ required: false }}
//                                     />
//                                 </Grid>

//                                 <Grid item xs={12} md={4}>
//                                     <WSTextField
//                                         id="customerAddress"
//                                         label="Address"
//                                         {...register("customerAddress")}
//                                         control={control}
//                                         size="small"
//                                         suffix={<HomeIcon fontSize="small" />}
//                                         rules={{ required: false }}
//                                     />
//                                 </Grid>

//                                 <Grid item xs={12} md={4}>
//                                     <WSDateField
//                                         id="invoiceDate"
//                                         name="invoiceDate"
//                                         label={"Invoice Date"}
//                                         dateFormat="DD-MM-YYYY"
//                                         denyFuturOrPast="custom"
//                                         control={control}
//                                         rules={{ required: "Invoice Date is required" }}
//                                     />
//                                 </Grid>
//                             </Grid>
//                         </Paper>

//                         {/* Barcode Scanner Section */}
//                         <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: alpha(theme.palette.primary.main, 0.02) }}>
//                             <Grid container spacing={2} alignItems="center">
//                                 <Grid item xs={12} md={6}>
//                                     <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
//                                         <Badge color="primary" variant="dot" invisible={!scanningInput}>
//                                             <TextField
//                                                 inputRef={barcodeRef}
//                                                 id="barcodeInput"
//                                                 label="Scan Barcode"
//                                                 value={barcodeInput}
//                                                 onChange={(e) => setBarcodeInput(e.target.value)}
//                                                 onKeyDown={handleBarcodeKeyPress}
//                                                 size="small"
//                                                 fullWidth
//                                                 placeholder="Scan or type barcode..."
//                                                 InputProps={{
//                                                     startAdornment: (
//                                                         <InputAdornment position="start">
//                                                             <QrCodeIcon color="primary" />
//                                                         </InputAdornment>
//                                                     ),
//                                                     endAdornment: (
//                                                         <InputAdornment position="end">
//                                                             <IconButton
//                                                                 size="small"
//                                                                 color="primary"
//                                                                 onClick={() => barcodeInput && handleBarcodeScan(barcodeInput)}
//                                                                 disabled={!barcodeInput}
//                                                             >
//                                                                 <SearchIcon />
//                                                             </IconButton>
//                                                         </InputAdornment>
//                                                     ),
//                                                 }}
//                                             />
//                                         </Badge>

//                                         <Tooltip title="Toggle Scanner">
//                                             <IconButton
//                                                 color={scanningInput ? "primary" : "default"}
//                                                 onClick={() => setScanningInput(!scanningInput)}
//                                                 sx={{
//                                                     bgcolor: scanningInput ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
//                                                 }}
//                                             >
//                                                 <QrCodeScannerIcon />
//                                             </IconButton>
//                                         </Tooltip>
//                                     </Box>
//                                 </Grid>

//                                 <Grid item xs={12} md={6}>
//                                     <Typography variant="caption" color="text.secondary">
//                                         <LocalOfferIcon fontSize="inherit" sx={{ mr: 0.5 }} />
//                                         Scan product barcode to auto-add item
//                                     </Typography>
//                                 </Grid>
//                             </Grid>
//                         </Paper>

//                         {/* Items Table */}
//                         <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                                 <ShoppingCartIcon color="primary" />
//                                 Invoice Items
//                                 <Chip label={fields.length} size="small" color="primary" />
//                             </Typography>

//                             <TableContainer sx={{ maxHeight: 400, overflow: 'auto' }}>
//                                 <Table size="small" stickyHeader>
//                                     <TableHead>
//                                         <TableRow>
//                                             <TableCell width={40}>#</TableCell>
//                                             <TableCell sx={{ minWidth: 230 }}>Product</TableCell>
//                                             <TableCell width={80}>HSN</TableCell>
//                                             <TableCell width={70} align="right">Qty</TableCell>
//                                             <TableCell width={90} align="right">Price</TableCell>
//                                             <TableCell width={70} align="right">Disc%</TableCell>
//                                             {/* <TableCell width={70} align="right">Tax%</TableCell> */}
//                                             <TableCell width={90} align="right">Total</TableCell>
//                                             <TableCell width={50} align="center">Action</TableCell>
//                                         </TableRow>
//                                     </TableHead>

//                                     <TableBody>
//                                         {fields.map((field, index) => (
//                                             <TableRow
//                                                 key={field.id}
//                                                 hover
//                                                 sx={{
//                                                     "& .MuiTableCell-root": {
//                                                         py: 2.5
//                                                     }
//                                                 }}
//                                             >
//                                                 <TableCell>{index + 1}</TableCell>

//                                                 <TableCell sx={{ minWidth: 250 }}>
//                                                     <WSTextField
//                                                         {...register(`items.${index}.productName`)}
//                                                         size="small"
//                                                         id="productName"
//                                                         label="Product Name"
//                                                         control={control}
//                                                         disabled

//                                                         sx={{
//                                                             width: "100%",
//                                                             "& .MuiInputBase-root": {
//                                                                 fontSize: 13
//                                                             }
//                                                         }}
//                                                     />
//                                                 </TableCell>

//                                                 <TableCell>
//                                                     <WSTextField
//                                                         id="hsnCode"
//                                                         {...register(`items.${index}.hsnCode`)}
//                                                         size="small"
//                                                         sx={{ width: 80 }}
//                                                         label={"HSN Code"}
//                                                         control={control}
//                                                         disabled
//                                                     />
//                                                 </TableCell>

//                                                 <TableCell align="right">
//                                                     <WSTextField
//                                                         id="quantity"
//                                                         {...register(`items.${index}.quantity`, {
//                                                             onChange: (event) => handleItemChange(index, 'quantity', event.target.value)
//                                                         })}
//                                                         type={TextType.AllowOnlyNumber}
//                                                         size="small"
//                                                         label={"Quantity"}
//                                                         sx={{ width: 60 }}
//                                                         control={control}
//                                                     />
//                                                 </TableCell>

//                                                 <TableCell align="right">
//                                                     <WSTextField
//                                                         id="unitPrice"
//                                                         {...register(`items.${index}.unitPrice`, {
//                                                             onChange: (event) => handleItemChange(index, 'unitPrice', event.target.value)
//                                                         })}
//                                                         type={TextType.Currency}
//                                                         currency={CurrencyType.Rupee}
//                                                         size="small"
//                                                         label={"Unit Price"}
//                                                         sx={{ width: 80 }}
//                                                         control={control}
//                                                     />
//                                                 </TableCell>

//                                                 <TableCell align="right">
//                                                     <WSTextField
//                                                         id="discount"
//                                                         {...register(`items.${index}.discount`, {
//                                                             onChange: (event) => handleItemChange(index, 'discount', event.target.value)
//                                                         })}
//                                                         type={TextType.AllowOnlyNumber}
//                                                         size="small"
//                                                         label="Discount"
//                                                         sx={{ width: 60 }}
//                                                         // suffix="%"
//                                                         control={control}
//                                                     />
//                                                 </TableCell>

//                                                 {/* <TableCell align="right">
//                                                     <WSTextField
//                                                         id="tax"
//                                                         {...register(`items.${index}.taxRate`)}
//                                                         type={TextType.Number}
//                                                         size="small"
//                                                         onChange={(e) => handleItemChange(index, 'taxRate', e.target.value)}
//                                                         sx={{ width: 60 }}
//                                                         suffix="%"
//                                                         control={control}
//                                                     />
//                                                 </TableCell> */}

//                                                 <TableCell align="right">
//                                                     <Typography variant="body2" fontWeight="bold" color="primary.main">
//                                                         {formatCurrency(Number(watch(`items.${index}.total`)) || 0)}
//                                                     </Typography>
//                                                 </TableCell>

//                                                 <TableCell align="center">
//                                                     <IconButton
//                                                         size="small"
//                                                         color="error"
//                                                         onClick={() => remove(index)}
//                                                     >
//                                                         <DeleteIcon fontSize="small" />
//                                                     </IconButton>
//                                                 </TableCell>
//                                             </TableRow>
//                                         ))}

//                                         {fields.length === 0 && (
//                                             <TableRow>
//                                                 <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
//                                                     <Typography color="text.secondary">
//                                                         No items added. Scan barcode to add items.
//                                                     </Typography>
//                                                 </TableCell>
//                                             </TableRow>
//                                         )}
//                                     </TableBody>
//                                 </Table>
//                             </TableContainer>

//                             {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
//                                 <Button
//                                     variant="outlined"
//                                     startIcon={<AddIcon />}
//                                     onClick={() => append({
//                                         id: '',
//                                         barcode: '',
//                                         productName: '',
//                                         hsnCode: '',
//                                         quantity: 1,
//                                         unitPrice: 0,
//                                         discount: 0,
//                                         taxRate: 0,
//                                         total: 0,
//                                     })}
//                                     size="small"
//                                 >
//                                     Add Manual Item
//                                 </Button>

//                                 <Typography variant="body2" color="text.secondary">
//                                     Total Items: {fields.length}
//                                 </Typography>
//                             </Box> */}
//                         </Paper>
//                     </Grid>

//                     {/* Right Column - Summary & Payment */}
//                     <Grid item xs={12} lg={4}>
//                         <Paper elevation={3} sx={{ p: 2, borderRadius: 2, position: 'sticky', top: 20 }}>
//                             {/* Payment Method */}
//                             <Box sx={{ mb: 3 }}>
//                                 <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
//                                     <PaymentIcon color="primary" />
//                                     Payment Method
//                                 </Typography>

//                                 <Grid container spacing={1}>
//                                     {['CASH', 'CARD', 'UPI', 'BANK'].map((method) => (
//                                         <Grid item xs={6} key={method}>
//                                             <Button
//                                                 fullWidth
//                                                 size="small"
//                                                 variant={paymentMethod === method ? "contained" : "outlined"}
//                                                 color={paymentMethod === method ? "primary" : "inherit"}
//                                                 onClick={() => setPaymentMethod(method)}
//                                                 sx={{
//                                                     textTransform: 'capitalize',
//                                                     py: 1,
//                                                     bgcolor: paymentMethod === method ? theme.palette.primary.main : 'transparent',
//                                                 }}
//                                             >
//                                                 {method === 'UPI' ? 'UPI' : method.charAt(0).toUpperCase() + method.slice(1)}
//                                             </Button>
//                                         </Grid>
//                                     ))}
//                                 </Grid>
//                             </Box>

//                             <Divider sx={{ my: 2 }} />

//                             {/* Invoice Summary */}
//                             <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
//                                 Invoice Summary
//                             </Typography>

//                             <Stack spacing={1.5}>
//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <Typography variant="body2" color="text.secondary">Subtotal:</Typography>
//                                     <Typography variant="body2" fontWeight="500">
//                                         {formatCurrency(calculatedValues.subtotal)}
//                                     </Typography>
//                                 </Box>

//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <Typography variant="body2" color="text.secondary">Discount:</Typography>
//                                     <Typography variant="body2" color="error.main">
//                                         -{formatCurrency(calculatedValues.totalDiscount)}
//                                     </Typography>
//                                 </Box>

//                                 {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
//                                     <Typography variant="body2" color="text.secondary">Tax (GST):</Typography>
//                                     <Typography variant="body2" color="success.main">
//                                         +{formatCurrency(calculatedValues.totalTax)}
//                                     </Typography>
//                                 </Box> */}

//                                 <Divider />

//                                 <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
//                                     <Typography variant="h6" sx={{ fontWeight: 600 }}>Total:</Typography>
//                                     <Typography variant="h5" color="primary.main" sx={{ fontWeight: 700 }}>
//                                         {formatCurrency(calculatedValues.total)}
//                                     </Typography>
//                                 </Box>

//                                 <Box sx={{
//                                     bgcolor: alpha(theme.palette.success.main, 0.1),
//                                     p: 1.5,
//                                     borderRadius: 1,
//                                     display: 'flex',
//                                     justifyContent: 'space-between',
//                                     alignItems: 'center',
//                                     mt: 1
//                                 }}>
//                                     <Typography variant="body2" sx={{ fontWeight: 600 }}>Amount to Pay:</Typography>
//                                     <Typography variant="h6" color="success.main" sx={{ fontWeight: 700 }}>
//                                         {formatCurrency(calculatedValues.total)}
//                                     </Typography>
//                                 </Box>
//                             </Stack>

//                             <Box sx={{ mt: 2, textAlign: 'center' }}>
//                                 <Chip
//                                     icon={<ReceiptIcon />}
//                                     label="80mm Thermal Receipt"
//                                     size="small"
//                                     variant="outlined"
//                                 />
//                             </Box>
//                         </Paper>
//                     </Grid>
//                 </Grid>
//             </form>

//             {/* Hidden print template */}
//             <div ref={printRef} style={{ display: 'none' }} />

//             {/* Floating Scan Button for Mobile */}
//             <Zoom in={true}>
//                 <Fab
//                     color="primary"
//                     sx={{ position: 'fixed', bottom: 16, right: 16, display: { xs: 'flex', md: 'none' } }}
//                     onClick={() => setScanningInput(true)}
//                 >
//                     <QrCodeScannerIcon />
//                 </Fab>
//             </Zoom>

//             <WSLoadingOverlay
//                 loading={loading}
//                 message="Please Wait..."
//             />
//         </Box>
//     );
// };

// export default InvoicePage;





import React, { useState, useEffect, useCallback, useRef } from "react";
import {
    Grid,
    Paper,
    Typography,
    Divider,
    Button,
    Box,
    IconButton,

    Chip,
    Avatar,
    alpha,
    useTheme,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Tooltip,
    Zoom,

    InputAdornment,
    Stack,

    Badge,
    TextField,
    Fab,
} from "@mui/material";
import {
    Add as AddIcon,
    Delete as DeleteIcon,
    Receipt as ReceiptIcon,
    Percent as PercentIcon,
    Calculate as CalculateIcon,
    Save as SaveIcon,
    QrCode as QrCodeIcon,
    ShoppingCart as CartIcon,
    Person as PersonIcon,
    ArrowForward as ArrowForwardIcon,
    ReceiptLong as ReceiptLongIcon,
    Download as DownloadIcon,
    Print as PrintIcon,
    Phone as PhoneIcon,
    ShoppingCartOutlined as ShoppingCartIcon,
    Email as EmailIcon,
    ArrowBack as ArrowBackIcon,
    CheckCircle as CheckCircleIcon,
    LocalOffer as LocalOfferIcon,
    QrCodeScanner as QrCodeScannerIcon,
    Search as SearchIcon,
    Payment as PaymentIcon,
    Home as HomeIcon,
    Cancel as CancelIcon,
} from "@mui/icons-material";
import { useForm, useFieldArray } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";

import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { callAPI, formatCurrency, Method } from "../../commonFunctions/CommonFunctions";
import WSTextField, { CurrencyType, TextType } from "../../Components/TextBox/WSTextBox";

import WSDateField from "../../Components/DateField/WSDateField";
import WSButton from "../../Components/Button/WSButton";
import WSLoadingOverlay from "../../Components/Loader/WSLoadingOverlay";
import WSPhone from "../../Components/Phone/WSPhone";

// Thermal print styles for 80mm paper
const thermalPrintStyles = `
  @page {
    size: 80mm auto;
    margin: 0;
  }
  @media print {
    body {
            font-family: Arial, sans-serif;
            font-size: 14px;
            margin: 0;
            padding: 0;
            line-height:2;
          }

           #thermal-receipt {
            width: 80mm;
            max-width: 80mm;
            margin: auto;
            padding: 4px;
          }
    
    .print-header {
      text-align: center;
      font-weight: bold;
      font-size: 22px;
      margin-bottom: 5px;
    }
    .print-shop {
      text-align: center;
      font-size: 14px;
      font-weight: 600;
      line-height:2;
      margin-bottom: 10px;
    }
    .print-divider {
      border-top: 1px dashed #000;
      margin: 5px 0;
    }
    .print-row{
  display:flex;
  justify-content:space-between;
  align-items:flex-start;
  margin:2px 0;
}
    .print-row .customerName{
    line-height:2;
    }

    .customer-line{
  word-break: break-word;
  white-space: normal;
}

    .print-row .phone{
    line-height:2;
    }

    .print-footer {
      text-align: center;
      margin-top: 10px;
      font-size: 9px;
    }
  }
`;

interface InvoiceItem {
    id: string;
    barcode: string;
    productName: string;
    hsnCode: string;
    quantity: number;
    unitPrice: number;
    discount: number;
    taxRate: number;
    total: number;
    productId: string;
}

interface InvoiceFormData {
    invoiceNo: string;
    invoiceDate: Date;
    customerName: string;
    customerPhone: string;
    customerAddress: string;
    items: InvoiceItem[];
    discount: number;
    notes: string;
}

const InvoicePage: React.FC = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const params = useParams();
    const id = params?.id;
    const { showMessage } = useSnackbar();

    const printRef = useRef<HTMLDivElement>(null);
    const barcodeRef = useRef<HTMLInputElement>(null);

    const [loading, setLoading] = useState(false);
    // const [scanning, setScanning] = useState(false);
    const [scanningInput, setScanningInput] = useState(false);
    const [barcodeInput, setBarcodeInput] = useState('');
    const [paymentMethod, setPaymentMethod] = useState('UPI'); // Default UPI
    const [calculatedValues, setCalculatedValues] = useState({
        subtotal: 0,
        totalDiscount: 0,
        totalTax: 0,
        total: 0,
    });

    const { control, register, watch, setValue, getValues, reset, handleSubmit } = useForm<InvoiceFormData>({
        defaultValues: {
            // invoiceNo: '',
            invoiceDate: new Date(),
            customerName: '',
            customerPhone: '',
            customerAddress: '',
            items: [],
            discount: 0,
            notes: '',
        }
    });

    const { fields, append, remove, replace } = useFieldArray({
        name: "items",
        control,
    });

    const watchItems = watch("items");

    useEffect(() => {
        barcodeRef.current?.focus();
    }, []);

    // Load existing invoice when editing
    useEffect(() => {
        if (!id) return;

        const fetchInvoice = async () => {
            try {
                setLoading(true);
                const resp: any = await callAPI(`Vyapar/SaleInvoice/${id}`, Method.GET);
                console.log('try to edit', resp)

                const inv = resp?.data ?? resp;
                if (!inv) return;

                console.log("Loaded invoice for edit:", inv);

                // Top-level invoice fields
                setValue("customerName", inv.customerName || "");
                setValue("customerPhone", inv.phoneNumber || "");
                setValue("customerAddress", inv.address || "");
                setValue("invoiceDate", inv.invoiceDate ? new Date(inv.invoiceDate) : new Date());

                // Invoice items -> form items
                const mappedItems = (inv.items || []).map((item: any) => ({
                    id: item.id,
                    barcode: item.itemCode || "",
                    productId: item.productId,
                    productName: item.product?.name || "",
                    hsnCode: item.hsnCode || item.product?.hsnSac || "",
                    quantity: item.quantity,
                    unitPrice: item.pricePerUnit,
                    discount: item.discount,
                    taxRate: item.tax || 0,
                    total: item.amount,
                }));

                replace(mappedItems);

                // Cash / totals on the right side
                setCalculatedValues({
                    subtotal: inv.subtotal ?? inv.total ?? 0,
                    totalDiscount: inv.discount ?? 0,
                    totalTax: inv.tax ?? 0,
                    total: inv.total ?? 0,
                });

                if (inv.paymentType) {
                    setPaymentMethod(inv.paymentType);
                }
            } catch (error) {
                console.error("Failed to load invoice:", error);
                showMessage("Failed to load invoice", "error");
            } finally {
                setLoading(false);
            }
        };

        fetchInvoice();
    }, [id, replace, setValue, showMessage]);

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {

            // Save (Ctrl + S)
            if (event.ctrlKey && event.key.toLowerCase() === "s") {
                event.preventDefault(); // prevent browser save page
                handleSave();
            }

            // Save & Print (Ctrl + P)
            if (event.ctrlKey && event.key.toLowerCase() === "p") {
                event.preventDefault(); // prevent browser print
                handleSaveAndPrint();
            }

            // Cancel (Esc)
            if (event.key === "Escape") {
                handleCancel();
            }
        };

        window.addEventListener("keydown", handleKeyDown);

        return () => {
            window.removeEventListener("keydown", handleKeyDown);
        };
    }, []);

    // Calculate invoice totals
    useEffect(() => {
        calculateInvoiceTotals();
    }, [watchItems]);

    const calculateInvoiceTotals = useCallback(() => {
        const items = getValues("items") || [];

        let subtotal = 0;
        let totalDiscount = 0;
        let totalTax = 0;

        items.forEach((item: any, index: number) => {
            const quantity = Number(item.quantity) || 1;
            const unitPrice = Number(item.unitPrice) || 0;
            const discount = Number(item.discount) || 0;
            const taxRate = Number(item.taxRate) || 0;

            const itemSubtotal = quantity * unitPrice;
            const itemDiscount = (itemSubtotal * discount) / 100;
            const taxableValue = itemSubtotal - itemDiscount;
            const itemTax = (taxableValue * taxRate) / 100;

            subtotal += itemSubtotal;
            totalDiscount += itemDiscount;
            totalTax += itemTax;

            // Update item total
            setValue(`items.${index}.total` as any, taxableValue + itemTax);
        });

        setCalculatedValues({
            subtotal,
            totalDiscount,
            totalTax,
            total: subtotal - totalDiscount + totalTax,
        });
    }, [watchItems, setValue, getValues]);

    // Handle barcode scan
    const handleBarcodeScan = async (barcode: string) => {
        try {
            setLoading(true);
            const response = await callAPI(`Vyapar/Product/by-barcode/${barcode}`, Method.GET);

            console.log("Barcode scan response:", response);

            if (response.success && response.data) {
                const product = response.data;

                // Add new item with scanned product
                append({
                    id: Date.now().toString(),
                    barcode: barcode,
                    productId: product.id,
                    productName: product.name,
                    hsnCode: product.hsnSac || '',
                    quantity: 1,
                    unitPrice: product.salePrice || 0,
                    discount: 0,
                    taxRate: product.gstPercent || 0,
                    total: product.salePrice || 0,
                });

                showMessage(`${product.name} added`, 'success');
                setBarcodeInput('');
                barcodeRef.current?.focus();
            } else {
                showMessage('Product not found', 'warning');
            }
        } catch (error) {
            showMessage('Failed to fetch product', 'error');
        } finally {
            setLoading(false);
        }
    };

    // Handle barcode input keypress
    const handleBarcodeKeyPress = (e: React.KeyboardEvent) => {
        if (e.key === "Enter") {
            e.preventDefault(); // 🚀 prevents form submit
            if (barcodeInput) {
                handleBarcodeScan(barcodeInput);
            }
        }
    };

    // Handle item change
    const handleItemChange = (index: number, field: string, value: any) => {

        setValue(`items.${index}.${field}` as any, value);

        // Recalculate after state update
        setTimeout(() => {
            calculateInvoiceTotals();
        }, 0);
    };

    const handleSave = () => {
        handleSubmit((data) => onSubmit(data, true))();
    };

    const handleSaveAndPrint = () => {
        handleSubmit((data) => onSubmit(data, true))();
    };

    const handleCancel = () => {
        navigate("/invoice/list");
    };

    // Thermal print function
    const handlePrint = (data: any) => {

        const printWindow = window.open('', '_blank', 'width=800,height=600');

        if (printWindow && printRef.current) {

            const shopName = "RANGOLI COLLECTIONS";
            const shopAddress = "Iritty Rd, Chavassery Near town bus stop, Kerala 670702";
            const shopPhone = "+91 7594032123";

            const invoiceDate = new Date(data.invoiceDate);

            const receiptHTML = `
<!DOCTYPE html>
<html>
<head>
<title>Print Receipt</title>
<style>${thermalPrintStyles}</style>
</head>

<body>
<div id="thermal-receipt">

  <div class="print-header">${shopName}</div>
  <div class="print-shop">${shopAddress}</div>
  <div class="print-shop">Ph: ${shopPhone}</div>

  <div style="text-align:center;font-weight:bold;font-size:12px;margin-top:4px;">
    SALES INVOICE
  </div>

  <div class="print-divider"></div>

  <div class="print-row">
  <span class="invoice">Invoice: ${data.invoiceNo}</span>

  <span style="display:flex;flex-direction:column;align-items:flex-end;line-height:1.2;">
    <span>Date: ${invoiceDate.toLocaleDateString()}</span>
    <span style="font-size:12px; margin-top:4px">Time: ${invoiceDate.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}</span>
  </span>
</div>

  <div class="customer-line">
  Customer: 
  <span style="font-size:12px">${data.customerName || 'Walk-in'} </span>
</div>

  <div class="print-row">
    <span>Phone: ${data.phoneNumber || 'N/A'}</span>
  </div>

  <div class="print-divider"></div>

  <table style="width:100%;font-size:11px;">
    <thead>
      <tr>
        <th style="text-align:left;">Item</th>
        <th style="text-align:right;">Qty</th>
        <th style="text-align:right;">Price</th>
        <th style="text-align:right;">Total</th>
      </tr>
    </thead>

    <tbody>
      ${data.items.map((item: any) => `
        <tr>
          <td style="text-align:left;">${item.productName.substring(0, 15)}</td>
          <td style="text-align:right;">${item.quantity}</td>
          <td style="text-align:right;">${item.pricePerUnit.toFixed(2)}</td>
          <td style="text-align:right;">${item.amount.toFixed(2)}</td>
        </tr>
      `).join('')}
    </tbody>
  </table>

  <div class="print-divider"></div>

  <div class="print-row">
    <span>Subtotal</span>
    <span>₹ ${calculatedValues.subtotal.toFixed(2)}</span>
  </div>

  <div class="print-row">
    <span>Discount</span>
    <span>- ₹ ${calculatedValues.totalDiscount.toFixed(2)}</span>
  </div>

  <div class="print-row" style="font-weight:bold;font-size:14px; margin-top:3px;">
    <span>TOTAL</span>
    <span>₹ ${data.total.toFixed(2)}</span>
  </div>

  <div class="print-divider"></div>

  <div class="print-row">
    <span>Payment</span>
    <span>${paymentMethod.toUpperCase()}</span>
  </div>

  <div class="print-footer">
    Thank you for shopping! <br/>
    Visit Again
  </div>

</div>
</body>
</html>
`;

            printWindow.document.write(receiptHTML);
            printWindow.document.close();
            printWindow.focus();

            setTimeout(() => {
                printWindow.print();
                printWindow.onafterprint = () => {
                    printWindow.close();
                };
            }, 300);
        }
    };

    // Submit handler
    const onSubmit = async (data: any, isPrint = false) => {
        console.log("data are", data);

        try {
            setLoading(true);

            const request = {
                ...calculatedValues,
                CustomerName: data.customerName || "Cash Customer",
                PhoneNumber: data.customerPhone || "",
                invoiceDate: data.invoiceDate || "",
                invoiceNo: data.invoiceNo || "",
                stateOfSupply: data.stateOfSupply || "",
                description: data.description || "",
                paymentType: paymentMethod,

                items: (data.items || []).map((item: any) => ({
                    productId: item.productId || "",
                    productName: item.productName || "",
                    itemCode: item.itemCode || "",
                    hsnCode: item.hsnCode || "",
                    description: item.description || "",
                    quantity: Number(item.quantity || 0),
                    pricePerUnit: Number(item.unitPrice || 0),
                    discount: Number(item.discount || 0),
                    amount: Number(item.amount || 0),
                    // total: Number(item.total) || 0,
                })),
            };

            let response;
            
            if (id) {
                response = await callAPI(`Vyapar/SaleInvoice/${id}`, Method.PUT, request);
            } else {
                response = await callAPI('Vyapar/SaleInvoice', Method.POST, request);
            }

            if (response?.success) {
                showMessage('Invoice saved successfully', 'success');

                // Check which action to perform
                if (isPrint) {
                    handlePrint(response.data);
                    reset(); // Clear form after printing
                }
                else {
                    navigate('/invoice/list');
                }
            }

        } catch (error: any) {
            console.error("Failed to save invoice:", error);
            showMessage(error.response?.data?.message || 'Failed to save invoice', 'error');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Box sx={{ p: 2, maxWidth: 1400, mx: 'auto' }}>
            <form onSubmit={handleSubmit((data) => onSubmit(data, false))}>
                {/* Header */}
                <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                    <Grid container spacing={2} alignItems="center">
                        {/* Billing Title */}
                        <Grid item xs={12} md={3}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Avatar sx={{ bgcolor: theme.palette.primary.main }}>
                                    <ReceiptIcon />
                                </Avatar>

                                <Box>
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>
                                        Start Billing
                                    </Typography>

                                    <Typography variant="caption" color="text.secondary">
                                        New Sale Invoice
                                    </Typography>
                                </Box>
                            </Box>
                        </Grid>

                        {/* Action Buttons */}
                        <Grid item xs={12} md={9}>
                            <Box
                                sx={{
                                    display: "flex",
                                    justifyContent: "flex-end",
                                    gap: 1,
                                    flexWrap: "wrap"
                                }}
                            >
                                <WSButton
                                    id="cancelBtn"
                                    variant="outlined"
                                    color="error"
                                    size="small"
                                    label="Cancel"
                                    onClick={() => navigate('/invoice/list')}
                                />

                                <WSButton
                                    id="saveAndPrintBtn"
                                    variant="contained"
                                    color="secondary"
                                    size="small"
                                    startIcon={<PrintIcon />}
                                    label="Save & Print"
                                    onClick={handleSaveAndPrint}
                                />

                                <WSButton
                                    id="saveBtn"
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    label="Save"
                                    type="submit"
                                    startIcon={<SaveIcon />}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Paper>

                <Grid container spacing={2}>
                    {/* Left Column - Customer & Items */}
                    <Grid item xs={12} lg={8}>
                        {/* Customer Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <PersonIcon color="primary" />
                                Customer Details
                            </Typography>

                            <Grid container spacing={2}>
                                <Grid item xs={12} md={4}>
                                    <WSTextField
                                        id="customerName"
                                        label="Customer Name"
                                        {...register("customerName")}
                                        control={control}
                                        size="small"
                                        suffix={<PersonIcon fontSize="small" />}
                                        rules={{ required: false }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <WSPhone
                                        id="customerPhone"
                                        label="Phone Number"
                                        {...register("customerPhone")}
                                        control={control}
                                        size="small"

                                        rules={{ required: false }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <WSTextField
                                        id="customerAddress"
                                        label="Address"
                                        {...register("customerAddress")}
                                        control={control}
                                        size="small"
                                        suffix={<HomeIcon fontSize="small" />}
                                        rules={{ required: false }}
                                    />
                                </Grid>

                                <Grid item xs={12} md={4}>
                                    <WSDateField
                                        id="invoiceDate"
                                        name="invoiceDate"
                                        label={"Invoice Date"}
                                        dateFormat="DD-MM-YYYY"
                                        denyFuturOrPast="custom"
                                        control={control}
                                        rules={{ required: "Invoice Date is required" }}
                                    />
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* Barcode Scanner Section */}
                        <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2, bgcolor: alpha(theme.palette.primary.main, 0.02) }}>
                            <Grid container spacing={2} alignItems="center">
                                <Grid item xs={12} md={6}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                        <Badge color="primary" variant="dot" invisible={!scanningInput}>
                                            <TextField
                                                inputRef={barcodeRef}
                                                id="barcodeInput"
                                                label="Scan Barcode"
                                                value={barcodeInput}
                                                onChange={(e) => setBarcodeInput(e.target.value)}
                                                onKeyDown={handleBarcodeKeyPress}
                                                size="small"
                                                fullWidth
                                                placeholder="Scan or type barcode..."
                                                InputProps={{
                                                    startAdornment: (
                                                        <InputAdornment position="start">
                                                            <QrCodeIcon color="primary" />
                                                        </InputAdornment>
                                                    ),
                                                    endAdornment: (
                                                        <InputAdornment position="end">
                                                            <IconButton
                                                                size="small"
                                                                color="primary"
                                                                onClick={() => barcodeInput && handleBarcodeScan(barcodeInput)}
                                                                disabled={!barcodeInput}
                                                            >
                                                                <SearchIcon />
                                                            </IconButton>
                                                        </InputAdornment>
                                                    ),
                                                }}
                                            />
                                        </Badge>

                                        <Tooltip title="Toggle Scanner">
                                            <IconButton
                                                color={scanningInput ? "primary" : "default"}
                                                onClick={() => setScanningInput(!scanningInput)}
                                                sx={{
                                                    bgcolor: scanningInput ? alpha(theme.palette.primary.main, 0.1) : 'transparent',
                                                }}
                                            >
                                                <QrCodeScannerIcon />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                </Grid>

                                <Grid item xs={12} md={6}>
                                    <Typography variant="caption" color="text.secondary">
                                        <LocalOfferIcon fontSize="inherit" sx={{ mr: 0.5 }} />
                                        Scan product barcode to auto-add item
                                    </Typography>
                                </Grid>
                            </Grid>
                        </Paper>

                        {/* Items Table */}
                        <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2 }}>
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                <ShoppingCartIcon color="primary" />
                                Invoice Items
                                <Chip label={fields.length} size="small" color="primary" />
                            </Typography>

                            <TableContainer sx={{ maxHeight: 400, overflow: 'auto' }}>
                                <Table size="small" stickyHeader>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell width={40}>#</TableCell>
                                            <TableCell sx={{ minWidth: 230 }}>Product</TableCell>
                                            <TableCell width={80}>HSN</TableCell>
                                            <TableCell width={70} align="right">Qty</TableCell>
                                            <TableCell width={90} align="right">Price</TableCell>
                                            <TableCell width={70} align="right">Disc%</TableCell>
                                            {/* <TableCell width={70} align="right">Tax%</TableCell> */}
                                            <TableCell width={90} align="right">Total</TableCell>
                                            <TableCell width={50} align="center">Action</TableCell>
                                        </TableRow>
                                    </TableHead>

                                    <TableBody>
                                        {fields.map((field, index) => (
                                            <TableRow
                                                key={field.id}
                                                hover
                                                sx={{
                                                    "& .MuiTableCell-root": {
                                                        py: 2.5
                                                    }
                                                }}
                                            >
                                                <TableCell>{index + 1}</TableCell>

                                                <TableCell sx={{ minWidth: 250 }}>
                                                    <WSTextField
                                                        {...register(`items.${index}.productName`)}
                                                        size="small"
                                                        id="productName"
                                                        label="Product Name"
                                                        control={control}
                                                        disabled

                                                        sx={{
                                                            width: "100%",
                                                            "& .MuiInputBase-root": {
                                                                fontSize: 13
                                                            }
                                                        }}
                                                    />
                                                </TableCell>

                                                <TableCell>
                                                    <WSTextField
                                                        id="hsnCode"
                                                        {...register(`items.${index}.hsnCode`)}
                                                        size="small"
                                                        sx={{ width: 80 }}
                                                        label={"HSN Code"}
                                                        control={control}
                                                        disabled
                                                    />
                                                </TableCell>

                                                <TableCell align="right">
                                                    <WSTextField
                                                        id="quantity"
                                                        {...register(`items.${index}.quantity`, {
                                                            onChange: (event) => handleItemChange(index, 'quantity', event.target.value)
                                                        })}
                                                        type={TextType.AllowOnlyNumber}
                                                        size="small"
                                                        label={"Quantity"}
                                                        sx={{ width: 60 }}
                                                        control={control}
                                                    />
                                                </TableCell>

                                                <TableCell align="right">
                                                    <WSTextField
                                                        id="unitPrice"
                                                        {...register(`items.${index}.unitPrice`, {
                                                            onChange: (event) => handleItemChange(index, 'unitPrice', event.target.value)
                                                        })}
                                                        type={TextType.Currency}
                                                        currency={CurrencyType.Rupee}
                                                        size="small"
                                                        label={"Unit Price"}
                                                        sx={{ width: 80 }}
                                                        control={control}
                                                    />
                                                </TableCell>

                                                <TableCell align="right">
                                                    <WSTextField
                                                        id="discount"
                                                        {...register(`items.${index}.discount`, {
                                                            onChange: (event) => handleItemChange(index, 'discount', event.target.value)
                                                        })}
                                                        type={TextType.AllowOnlyNumber}
                                                        size="small"
                                                        label="Discount"
                                                        sx={{ width: 60 }}
                                                        // suffix="%"
                                                        control={control}
                                                    />
                                                </TableCell>

                                                {/* <TableCell align="right">
                                                    <WSTextField
                                                        id="tax"
                                                        {...register(`items.${index}.taxRate`)}
                                                        type={TextType.Number}
                                                        size="small"
                                                        onChange={(e) => handleItemChange(index, 'taxRate', e.target.value)}
                                                        sx={{ width: 60 }}
                                                        suffix="%"
                                                        control={control}
                                                    />
                                                </TableCell> */}

                                                <TableCell align="right">
                                                    <Typography variant="body2" fontWeight="bold" color="primary.main">
                                                        {formatCurrency(Number(watch(`items.${index}.total`)) || 0)}
                                                    </Typography>
                                                </TableCell>

                                                <TableCell align="center">
                                                    <IconButton
                                                        size="small"
                                                        color="error"
                                                        onClick={() => remove(index)}
                                                    >
                                                        <DeleteIcon fontSize="small" />
                                                    </IconButton>
                                                </TableCell>
                                            </TableRow>
                                        ))}

                                        {fields.length === 0 && (
                                            <TableRow>
                                                <TableCell colSpan={9} align="center" sx={{ py: 4 }}>
                                                    <Typography color="text.secondary">
                                                        No items added. Scan barcode to add items.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                </Table>
                            </TableContainer>

                            {/* <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mt: 2 }}>
                                <Button
                                    variant="outlined"
                                    startIcon={<AddIcon />}
                                    onClick={() => append({
                                        id: '',
                                        barcode: '',
                                        productName: '',
                                        hsnCode: '',
                                        quantity: 1,
                                        unitPrice: 0,
                                        discount: 0,
                                        taxRate: 0,
                                        total: 0,
                                    })}
                                    size="small"
                                >
                                    Add Manual Item
                                </Button>

                                <Typography variant="body2" color="text.secondary">
                                    Total Items: {fields.length}
                                </Typography>
                            </Box> */}
                        </Paper>
                    </Grid>

                    {/* Right Column - Summary & Payment */}
                    <Grid item xs={12} lg={4}>
                        <Paper elevation={3} sx={{ p: 2, borderRadius: 2, position: 'sticky', top: 20 }}>
                            {/* Payment Method */}
                            <Box sx={{ mb: 3 }}>
                                <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2, display: 'flex', alignItems: 'center', gap: 1 }}>
                                    <PaymentIcon color="primary" />
                                    Payment Method
                                </Typography>

                                <Grid container spacing={1}>
                                    {['CASH', 'CARD', 'UPI', 'BANK'].map((method) => (
                                        <Grid item xs={6} key={method}>
                                            <Button
                                                fullWidth
                                                size="small"
                                                variant={paymentMethod === method ? "contained" : "outlined"}
                                                color={paymentMethod === method ? "primary" : "inherit"}
                                                onClick={() => setPaymentMethod(method)}
                                                sx={{
                                                    textTransform: 'capitalize',
                                                    py: 1,
                                                    bgcolor: paymentMethod === method ? theme.palette.primary.main : 'transparent',
                                                }}
                                            >
                                                {method === 'UPI' ? 'UPI' : method.charAt(0).toUpperCase() + method.slice(1)}
                                            </Button>
                                        </Grid>
                                    ))}
                                </Grid>
                            </Box>

                            <Divider sx={{ my: 2 }} />

                            {/* Invoice Summary */}
                            <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
                                Invoice Summary
                            </Typography>

                            <Stack spacing={1.5}>
                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Subtotal:</Typography>
                                    <Typography variant="body2" fontWeight="500">
                                        {formatCurrency(calculatedValues.subtotal)}
                                    </Typography>
                                </Box>

                                <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Discount:</Typography>
                                    <Typography variant="body2" color="error.main">
                                        -{formatCurrency(calculatedValues.totalDiscount)}
                                    </Typography>
                                </Box>

                                {/* <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <Typography variant="body2" color="text.secondary">Tax (GST):</Typography>
                                    <Typography variant="body2" color="success.main">
                                        +{formatCurrency(calculatedValues.totalTax)}
                                    </Typography>
                                </Box> */}

                                <Divider />

                                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                    <Typography variant="h6" sx={{ fontWeight: 600 }}>Total:</Typography>
                                    <Typography variant="h5" color="primary.main" sx={{ fontWeight: 700 }}>
                                        {formatCurrency(calculatedValues.total)}
                                    </Typography>
                                </Box>

                                <Box sx={{
                                    bgcolor: alpha(theme.palette.success.main, 0.1),
                                    p: 1.5,
                                    borderRadius: 1,
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    mt: 1
                                }}>
                                    <Typography variant="body2" sx={{ fontWeight: 600 }}>Amount to Pay:</Typography>
                                    <Typography variant="h6" color="success.main" sx={{ fontWeight: 700 }}>
                                        {formatCurrency(calculatedValues.total)}
                                    </Typography>
                                </Box>
                            </Stack>

                            <Box sx={{ mt: 2, textAlign: 'center' }}>
                                <Chip
                                    icon={<ReceiptIcon />}
                                    label="80mm Thermal Receipt"
                                    size="small"
                                    variant="outlined"
                                />
                            </Box>
                        </Paper>
                    </Grid>
                </Grid>
            </form>

            {/* Hidden print template */}
            <div ref={printRef} style={{ display: 'none' }} />

            {/* Floating Scan Button for Mobile */}
            <Zoom in={true}>
                <Fab
                    color="primary"
                    sx={{ position: 'fixed', bottom: 16, right: 16, display: { xs: 'flex', md: 'none' } }}
                    onClick={() => setScanningInput(true)}
                >
                    <QrCodeScannerIcon />
                </Fab>
            </Zoom>

            <WSLoadingOverlay
                loading={loading}
                message="Please Wait..."
            />
        </Box>
    );
};

export default InvoicePage;